var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAndroid = function SvgAndroid(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M32 2V45C31.9982 46.6561 30.6561 47.9982 29 48H37C38.6561 47.9982 39.9982 46.6561 40 45V2H32Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6H21C20.4477 6 20 6.44772 20 7C20 7.55228 20.4477 8 21 8H31C31.5523 8 32 7.55228 32 7C32 6.44772 31.5523 6 31 6Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 0H15C12.2399 0.00319616 10.0032 2.2399 10 5V45C10.0032 47.7601 12.2399 49.9968 15 50H37C39.7601 49.9968 41.9968 47.7601 42 45V5C41.9968 2.2399 39.7601 0.00319616 37 0ZM40 45C39.9982 46.6561 38.6561 47.9982 37 48H15C13.3439 47.9982 12.0018 46.6561 12 45V42H40V45ZM12 5V40H40V5C39.9982 3.34388 38.6561 2.00176 37 2H15C13.3439 2.00176 12.0018 3.34388 12 5Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 46H29C29.5523 46 30 45.5523 30 45C30 44.4477 29.5523 44 29 44H23C22.4477 44 22 44.4477 22 45C22 45.5523 22.4477 46 23 46Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAndroid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/android.eecedaf399b4d4d720df75000da485d3.svg";